import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";

export function useGetTokenIntegracao() {
  const { invocarApi, ...outrasPropriedades } = useApiBase();

  const getTokenIntegracao = useCallback(() => {
    return invocarApi({
      baseURL: VariaveisAmbiente.apiMasterUrl,
      url: `/api/token/integradores/${btoa("s@urusIntegradores")}`,
      method: "GET",
      enviarTokenUsuario: false,
    });
  }, [invocarApi]);

  return {
    ...outrasPropriedades,
    getTokenIntegracao,
  };
}

